import { Avatar } from "../../components/Avatar/Avatar";
import { AdminUser } from "./api";
import { humanizeRelativeDate } from "./relativeTime";
import styles from "./UsersPage.module.css";

interface Props {
  user: AdminUser;
  /** Append "you" marker after name when this is the current user's row. */
  isSelf?: boolean;
}

function projectsLabel(u: AdminUser): string {
  if (u.role === "super_admin") return "all projects";
  if (u.projects_count === 0) return "0 projects";
  if (u.projects_count === 1) return "1 project";
  return `${u.projects_count} projects`;
}

/**
 * User preview card used inside Promote / Demote / Disable / Re-enable modals.
 * Shows avatar + name + role-aware meta line (email · projects · last login).
 * Mockup L504-L510 / L565-L570 / L629-L634.
 */
export function UserPreviewCard({ user, isSelf }: Props) {
  const last = humanizeRelativeDate(user.last_login_at);
  const lastLabel =
    last === "—"
      ? "never signed in"
      : last === "just now"
        ? "last login just now"
        : `last login ${last}`;
  return (
    <div className={styles.userPreview}>
      <Avatar name={user.name} size={40} />
      <div className={styles.userPreviewInfo}>
        <div className={styles.userPreviewName}>
          <span>{user.name}</span>
          {isSelf && <span className={styles.youMark}>you</span>}
        </div>
        <div className={styles.userPreviewMeta}>
          {user.email} · {projectsLabel(user)} · {lastLabel}
        </div>
      </div>
    </div>
  );
}
